import { Box, Button, Checkbox, Grid, Stack } from '@mui/material'
import { styles } from './styles'
import { useFormContext, useWatch } from 'react-hook-form'
import { useCallback, useState } from 'react'
import { PreviewFile, UploadFiles } from '../../components/UploadFiles'
import type { FileDocumentProps } from './types'

export const FileDocument = (props: FileDocumentProps) => {
  const { setDeletedFiles, setNewFiles } = props
  const files: Array<File> = useWatch({
    name: 'files',
    defaultValue: [],
  })

  const { setValue } = useFormContext()

  const [selected, setSelected] = useState<number[]>([])

  const checkboxHandle = useCallback(
    (id: number) => {
      const newSelected = selected.includes(id)
        ? selected.filter((item) => item !== id)
        : [...selected, id]

      setSelected(newSelected)
    },
    [selected]
  )

  const deletedFiles = useCallback(() => {
    const filterArray =
      Array.isArray(files) &&
      files?.filter((_, index) => !selected.includes(index))
    setValue('files', filterArray)
    setDeletedFiles(selected)
    setSelected([])
  }, [selected, files])

  return (
    <Box sx={styles.root}>
      {Array.isArray(files) && !!files.length && (
        <Grid spacing={1.5} container>
          {files?.map((item, index) => (
            <Grid key={index.toString()} item sm={4}>
              <PreviewFile file={item}>
                <Checkbox
                  checked={selected.includes(index)}
                  onChange={() => checkboxHandle(index)}
                  size={'small'}
                  color={'primary'}
                />
              </PreviewFile>
            </Grid>
          ))}
        </Grid>
      )}
      {Array.isArray(files) && !!files.length && (
        <Stack mt={1.5} mb={3} spacing={1} direction={'row'}>
          <Button onClick={deletedFiles} color={'info'} variant={'outlined'}>
            Удалить
          </Button>
        </Stack>
      )}
      <UploadFiles name="files" setNewFiles={setNewFiles} />
    </Box>
  )
}
